export const populateIpaffsModalData = (items) => {
  const ipaffsItems = {};
  const categories = items?.map((e) => e?.categoryId);
  categories?.forEach((e, i) => {
    ipaffsItems[i + 1] = {};
    ipaffsItems[i + 1]['id'] = i + 1;
    ipaffsItems[i + 1]['itemId'] = i;
    ipaffsItems[i + 1]['value'] = parseInt(e, 10);
    ipaffsItems[i + 1]['riskCategory'] = parseInt(e, 10);
    ipaffsItems[i + 1]['consolidatedIpaffs'] = items[i]?.consolidatedIpaffs || '';
    ipaffsItems[i + 1]['origin'] = items[i]?.origin || '';
    ipaffsItems[i + 1]['riskCategoryName'] = items[i]?.riskCategoryName || '';
    ipaffsItems[i + 1]['ipaffsHSCode'] = items[i]?.ipaffsHSCode || '';
  });
  return ipaffsItems ?? {};
};

export const getButtonStyle = (isActiveStep) => {
  return isActiveStep ? { color: 'black', background: '#FFF' } : { color: 'black', background: '#F0F4F9' };
};

export const showCheckIpaffsButton = (direction) => {
  const requiredRoutes = [2, 10, 11];
  const directionSelected = direction ? parseInt(direction, 10) : null;
  if (directionSelected !== null && requiredRoutes.includes(directionSelected)) {
    return true;
  }
  return false;
};
